import { combineReducers } from 'redux';
import allNumbers from './Numbers/allNumbers';
import numberByID from './Numbers/numberByID';

export default combineReducers({
  allNumbers,
  numberByID,
});
